import gql from 'graphql-tag';

export const PDF_REQUEST_FIELDS = gql`
	fragment PdfRequestFields on PdfRequest {
		_id
		createdDate
		createdById
		lastModifiedDate
		lastModifiedById
		orgId
		projectId
		versionId
		bookId
		itemId
		orgCode
		type
		index
		attempts
		status
		name
		errorMessage
		warningMessage
		totalPages
		readyPages
		readyTimestamp
		isNotReadyThumbnail
		md5
		progress
		s3uri
		s3uriParsedText
		system
		useOCR
		pdfType
		pdfParams
	}
`;
